import { useState } from "react";
import { Box } from "@mui/material";
import Detail from "../../main/detail/Detail";
import { rsActiveMenu } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import { useLocation } from "react-router-dom";
import MagFooterInpho from "./MagFooterInpho";
import FooterLinks from "./Links/FooterLinks";
import FooterNetworks from "./Networks/FooterNetworks";

export default function MagFooterManage() {
  const location = useLocation();
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const [expanded, setExpanded] = useState(
    location.state && location.state.expanded
      ? location.state.expanded
      : "panel9"
  );

  return (
    <Detail
      breadChilds={{
        backButtonDef: {
          state: location.state,
          replace: true,
        },
        backURL: "/magmanagment",
        title: "مدیریت محتوا",
        childs: [
          { name: msActiveMenu.pageTitle, url: "/magmanagment" },
          {
            name: "مدیریت فوتر",
            url: "/magFooterManage",
          },
        ],
      }}
    >
      <Box>
        <MagFooterInpho />
        <FooterLinks expanded={expanded} setExpanded={setExpanded} />
        <FooterNetworks expanded={expanded} setExpanded={setExpanded} />
      </Box>
    </Detail>
  );
}
